export default __webpack_public_path__ + "static/media/rectangles-no-8.422ad91e.ogg";